// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BarFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BarFilledIcon" ref={forwardedRef} {...props}>
      <path d="M13.485 2.25h-6.97S4.83 4.994 4.425 7.501a11 11 0 0 0-.088.68c-.29 2.94 2.136 5.242 5.036 5.536v3.533H5.75v1.5h8.75v-1.5h-3.627v-3.563c2.79-.395 5.072-2.649 4.79-5.507a11 11 0 0 0-.087-.679c-.405-2.507-2.091-5.251-2.091-5.251m-6.093 1.5h5.216a20 20 0 0 1 .414.826c.34.721.684 1.564.904 2.387H6.074c.22-.823.563-1.666.904-2.387A20 20 0 0 1 7.392 3.75" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const BarFilledIcon = /* @__PURE__ */ Object.assign(
  BarFilledIconComponent,
  { displayName: 'BarFilledIcon' },
);
